/**
 * CF7 Submission Toasts
 *
 * Listens for Contact Form 7 DOM events and shows toast notifications
 * matching the Figma design (accent bar + icon + text + close).
 */

const ICONS = {
	success: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/></svg>`,
	error: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" fill="currentColor"/></svg>`,
	warning: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z" fill="currentColor"/></svg>`,
};

const MESSAGES = {
	success: {
		title: 'Details received',
		message: "We'll be in touch shortly with everything you need.",
	},
	spam: {
		title: 'Submission blocked',
		message: 'Your message was flagged as spam. Please try again.',
	},
	invalid: {
		title: 'Please check your details',
		message: 'Some required fields are missing or incorrect.',
	},
	error: {
		title: 'Something went wrong',
		message: 'Please try again shortly.',
	},
};

let toastEl = null;
let autoDismissTimer = null;

function getOrCreateToast() {
	if ( toastEl ) return toastEl;

	toastEl = document.createElement( 'div' );
	toastEl.className = 'cf7-toast';
	toastEl.innerHTML = `
		<div class="cf7-toast__accent"></div>
		<div class="cf7-toast__body">
			<div class="cf7-toast__icon"></div>
			<div class="cf7-toast__text">
				<p class="cf7-toast__title"></p>
				<p class="cf7-toast__message"></p>
			</div>
			<button class="cf7-toast__close" type="button" aria-label="Close notification">
				<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" fill="currentColor"/></svg>
			</button>
		</div>
	`;

	toastEl.querySelector( '.cf7-toast__close' ).addEventListener( 'click', () => hide() );
	document.body.appendChild( toastEl );

	return toastEl;
}

function show( status, title, message ) {
	const el = getOrCreateToast();

	// Reset classes
	el.className = `cf7-toast cf7-toast--${ status }`;

	// Set content
	el.querySelector( '.cf7-toast__icon' ).innerHTML = ICONS[ status ] || ICONS.error;
	el.querySelector( '.cf7-toast__title' ).textContent = title;
	el.querySelector( '.cf7-toast__message' ).textContent = message;

	// Show with animation
	requestAnimationFrame( () => {
		el.classList.add( 'is-visible' );
	} );

	// Auto-dismiss after 6s
	clearTimeout( autoDismissTimer );
	autoDismissTimer = setTimeout( () => hide(), 6000 );
}

function hide() {
	if ( ! toastEl ) return;
	clearTimeout( autoDismissTimer );
	toastEl.classList.remove( 'is-visible' );
}

export const Cf7Toast = {
	init() {
		document.addEventListener( 'wpcf7mailsent', () => {
			show( 'success', MESSAGES.success.title, MESSAGES.success.message );
		} );

		document.addEventListener( 'wpcf7invalid', ( e ) => {
			const fields = e.detail?.apiResponse?.invalid_fields;
			if ( fields && fields.length ) {
				const count = fields.length;
				show(
					'warning',
					MESSAGES.invalid.title,
					`${ count } field${ count > 1 ? 's' : '' } need${ count === 1 ? 's' : '' } your attention.`
				);
			} else {
				show( 'warning', MESSAGES.invalid.title, MESSAGES.invalid.message );
			}
		} );

		document.addEventListener( 'wpcf7mailfailed', () => {
			show( 'error', MESSAGES.error.title, MESSAGES.error.message );
		} );

		document.addEventListener( 'wpcf7spam', () => {
			show( 'error', MESSAGES.spam.title, MESSAGES.spam.message );
		} );
	},
};
